import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-obs-commission',
  templateUrl: './obs-commission.component.html',
  styleUrls: ['./obs-commission.component.scss']
})
export class ObsCommissionComponent implements OnInit, OnChanges {
  @Input() observations: string = null;

  _isInRole = false;
  @Input()
  set isInRole(value) {
    this._isInRole = value;
  }

  get isInRole() {
    return this._isInRole;
  }

  _isInState = false;
  @Input()
  set isInState(value) {
    this._isInState = value;
  }

  get isInState() {
    return this._isInState;
  }

  @Output() observationsUpdated = new EventEmitter<string>();

  obsFormGroup: UntypedFormGroup;
  MAX_LENGTH = 1_000;
  get ObservationsText () {
    return this.obsFormGroup?.get('observations_commission')?.value;
  }
  constructor(public formBuilder: UntypedFormBuilder) {
    this.initFormGroup();
  }

  ngOnInit() {

  }
  setObservations(changes: SimpleChanges) {
    if (this.obsFormGroup) {
      this.obsFormGroup.patchValue({observations_commission: changes.observations.currentValue});
    }
  }

  initFormGroup() {
    this.obsFormGroup = this.formBuilder.group({
      observations_commission: ['', Validators.maxLength(1000)]
    });

    this.obsFormGroup.controls['observations_commission'].valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((obs) => {
        this.observationsUpdated.emit(obs);
      });
  }

  InRoleInState(isInRole = this._isInRole, isInState = this._isInState) {
    return (!isInRole || !isInState);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.isInRole && changes.isInRole.isFirstChange() && changes.isInRole.currentValue !== null) &&
        (changes.isInState && changes.isInState.isFirstChange() && changes.isInState.currentValue !== null)) {
      if (this.InRoleInState(changes.isInRole.currentValue, changes.isInState.currentValue)) {
        setTimeout(() => this.obsFormGroup.disable(), 100);
      }
    }

    if (changes.observations && changes.observations.isFirstChange() && changes.observations.currentValue !== null) {
      this.setObservations(changes);
    }
  }
}
